/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import gql from 'graphql-tag';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';

import { DeliveryOrderDetailFragmentDoc } from '../../../hooks/useCart/GraphQL/Cart.generated';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type DeliveryPreferenceType = 'CURBSIDE' | 'DOOR' | 'LEAVE_AT_DOOR';

export type OrderType =
  | 'CATERING'
  | 'CATERING_DELIVERY'
  | 'CATERING_PICKUP'
  | 'DELIVERY'
  | 'IN_STORE'
  | 'PICKUP';

export type OrdersInputV2 = {
  readonly includeCanceledOrders?: boolean | null | undefined;
  readonly includePlacedOrders?: boolean | null | undefined;
  readonly page: number;
  readonly take: number;
};

export type ValidOrdersV2QueryVariables = Exact<{
  input: Types.OrdersInputV2;
}>;

export type ValidOrdersV2Query = {
  readonly ordersV2:
    | {
        readonly __typename: 'OrdersResponseSuccess';
        readonly orders: ReadonlyArray<{
          readonly __typename: 'Order';
          readonly id: string;
          readonly orderType: Types.OrderType;
          readonly wantedTime: string;
          readonly description: string;
          readonly total: number | null;
          readonly isCanceled: boolean;
          readonly lineItems: ReadonlyArray<{
            readonly __typename: 'LineItem';
            readonly id: string;
            readonly customName: string | null;
            readonly isCustom: boolean;
            readonly product: {
              readonly __typename: 'Product';
              readonly id: string;
              readonly name: string;
              readonly isCustom: boolean;
              readonly categoryName: string;
            };
          }>;
          readonly asset: { readonly url: string };
          readonly restaurant: {
            readonly __typename: 'Restaurant';
            readonly id: string;
            readonly name: string;
            readonly isOutpost: boolean;
            readonly slug: string;
          };
          readonly deliveryOrderDetail: {
            readonly __typename: 'DeliveryOrderDetail';
            readonly id: string;
            readonly tip: number;
            readonly deliveryFee: number;
            readonly vendor: string;
            readonly orderId: string;
            readonly vendorRestaurantId: string;
            readonly estimatedDeliveryTime: string | null;
            readonly address: {
              readonly __typename: 'Address';
              readonly id: string;
              readonly street: string;
              readonly secondaryStreet: string | null;
              readonly city: string;
              readonly state: string;
              readonly country: string;
              readonly zipCode: string;
              readonly deliveryPreference: Types.DeliveryPreferenceType;
              readonly googlePlaceId: string;
              readonly latitude: number;
              readonly longitude: number;
              readonly name: string | null;
              readonly notes: string | null;
            } | null;
          } | null;
        }>;
      }
    | {
        readonly __typename: 'ValidationError';
        readonly fieldErrors: ReadonlyArray<{ readonly field: string; readonly message: string }>;
      };
};

export const ValidOrdersV2Document = gql`
  query validOrdersV2($input: OrdersInputV2!) {
    ordersV2(input: $input) {
      __typename
      ... on OrdersResponseSuccess {
        orders {
          id
          __typename
          orderType
          wantedTime
          description
          total
          isCanceled
          lineItems {
            id
            __typename
            customName
            isCustom
            product {
              id
              __typename
              name
              isCustom
              categoryName
            }
          }
          asset {
            url
          }
          restaurant {
            id
            __typename
            name
            isOutpost
            slug
          }
          deliveryOrderDetail {
            ...DeliveryOrderDetail
          }
        }
      }
      ... on ValidationError {
        fieldErrors {
          field
          message
        }
      }
    }
  }
  ${DeliveryOrderDetailFragmentDoc}
`;

export function useValidOrdersV2Query(
  options: Omit<Urql.UseQueryArgs<ValidOrdersV2QueryVariables>, 'query'>,
) {
  return Urql.useQuery<ValidOrdersV2Query, ValidOrdersV2QueryVariables>({
    query: ValidOrdersV2Document,
    ...options,
  });
}
